<template>
  <div
    class="emd-form-group"
    :class="[
        `_state_${state}`,
        {
            '_inline': inline,
        }
    ]"
  >
    <label
      data-testid="form-group-label"
      v-if="label"
      class="emd-label"
      :class="{'_required': required}"
      :for="labelFor"
    >
      {{ label }}
    </label>
    <slot />
    <p
      :data-cy="feedback.dataCy"
      v-for="feedback in activeFeedbacks"
      :key="feedback.msg"
      class="emd-input-feedback"
      data-testid="form-group-feedback"
    >
      {{feedback.msg}}
    </p>
  </div>
</template>

<script>

export default {
  name: 'EmdFormGroup',
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: '',
      required: false,
      validator: (value) => ['success', 'warning', 'error', 'info', ''].includes(value)
    },
    feedbacks: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      required: false
    },
    labelFor: {
      required: false,
      type: String
    }
  },
  computed: {
    activeFeedbacks () {
      return this.feedbacks.filter(feedback => feedback.condition)
    }
  }
}
</script>
